import React, {
  createContext,
  useCallback,
  useState,
  useContext,
  useEffect,
} from 'react';
import { Cookies } from 'react-cookie';
import { collection, getDocs, query, where } from 'firebase/firestore';
import ICompany from '~/interfaces/ICompany';
import { DB } from '~/services/firebase';
import IPayment from '~/interfaces/IPayment';
import { bff } from '~/services/bff';

// import api from '~/services/api';
// import { API_URL_REGISTER, API_URL_LOGIN } from '~/services/api/routes';

interface UserData {
  uid: string;
  email: string;
  name: string;
  avatar: string | null;
  instance_name?: string;
  isAdmin?: boolean;
}

interface AuthState {
  user: UserData;
  // token: string;
  // permissions: string[];
}

/* interface SignInCredentials {
  email: string;
  password: string;
} */

export interface SignUpData {
  name: string;
  email: string;
  password: string;
  password_confirmation: string;
}

interface AuthContextData {
  // signUp(data: SignUpData): Promise<void>;
  // signIn(credentials: SignInCredentials): Promise<void>;
  // can(permission: string): boolean;
  // permissions: string[];
  user: UserData;
  company: ICompany;
  payments: IPayment[];
  signOut(): void;
  updateUser(user: UserData): void;
  updateCompany(company: ICompany): void;
  loadCompany: () => Promise<void>;
}

const cookies = new Cookies();
const { REACT_APP_APP_NAME } = process.env;

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

const { REACT_APP_FIREBASE_PROJECT } = process.env;

export const AuthProvider: React.FC = ({ children }) => {
  const [company, setCompany] = useState({} as ICompany);
  const [payments, setPayments] = useState<IPayment[]>([]);
  const [data, setData] = useState<AuthState>(() => {
    const user = cookies.get(`@${REACT_APP_APP_NAME}:user`);
    // const token = cookies.get(`@${REACT_APP_APP_NAME}:token`);
    // const permissions = cookies.get(`@${REACT_APP_APP_NAME}:permissions`);

    if (user) {
      return {
        user,
        // token,
        // permissions,
      };
    }
    return {} as AuthState;
  });

  const updateUser = useCallback(
    user => {
      setData({
        ...data,
        user: { ...data.user, ...user },
      });

      cookies.set(`@${REACT_APP_APP_NAME}:user`, JSON.stringify(user), {
        path: '/',
      });
    },
    [data],
  );

  const updateCompany = useCallback((companyData: ICompany) => {
    setCompany(companyData);
  }, []);

  const loadCompany = useCallback(async () => {
    await bff.delete(`/companies/${REACT_APP_FIREBASE_PROJECT}`);
    const response = await bff.get(`/companies/${REACT_APP_FIREBASE_PROJECT}`);
    setCompany(response.data);
    // const q = query(
    //   collection(DB, 'companies'),
    //   where('user_id', '==', data.user.uid),
    // );
    // const querySnapshot = await getDocs(q);

    // if (querySnapshot.docs.length > 0) {
    //   const aux = querySnapshot.docs[0].data() as ICompany;
    //   setCompany({
    //     ...aux,
    //     uid: querySnapshot.docs[0].id,
    //   });
    // }
  }, []);

  const loadPayments = useCallback(async () => {
    const q = query(
      collection(DB, 'payments'),
      where('user_id', '==', data.user.uid),
    );
    const querySnapshot = await getDocs(q);

    const items: IPayment[] = [];

    querySnapshot.docs.forEach(item => {
      const parseItem = {
        ...item.data(),
        uid: item.id,
      } as IPayment;

      items.push(parseItem);
    });

    setPayments(items);
  }, [data]);

  const signOut = useCallback(() => {
    cookies.remove(`@${REACT_APP_APP_NAME}:user`);
    cookies.remove(`@${REACT_APP_APP_NAME}:language`);
    setData({} as AuthState);
  }, []);

  useEffect(() => {
    if (data.user && data.user.uid) {
      loadCompany();
      loadPayments();
    }
  }, [data, loadCompany, loadPayments]);

  return (
    <AuthContext.Provider
      value={{
        // can,
        // permissions: data.permissions,
        // signIn,
        // signUp,
        signOut,
        payments,
        updateUser,
        updateCompany,
        loadCompany,
        user: data.user,
        company,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth(): AuthContextData {
  const context = useContext(AuthContext);
  return context;
}
